// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c387b2ad","396":"0980920b","453":"95c142ae","455":"af129a42","977":"23368f54"}[chunkId] + ".chunk.js";
};